/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
/** @packageDocumentation
 * @module Core
 */

/**
 * Logger categories used by this package
 * @note All logger categories in this package start with the `presentation-common` prefix.
 * @see [Logger]($bentley)
 * @public
 */
export enum PresentationCommonLoggerCategory {
  Package = "presentation-common",
}
